"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CoreJsonMapper = exports.CoreDynamoMapper = void 0;
var core_dynamodb_1 = require("./core-dynamodb");
Object.defineProperty(exports, "CoreDynamoMapper", { enumerable: true, get: function () { return core_dynamodb_1.CoreDynamoMapper; } });
var core_json_1 = require("./core-json");
Object.defineProperty(exports, "CoreJsonMapper", { enumerable: true, get: function () { return core_json_1.CoreJsonMapper; } });
